// CAP Phase 1 status registry.
// Canonical statuses: open, awaiting_evidence, in_progress, awaiting_reviewer, deferred, closed
// Legacy `submitted_for_review` is normalized to `awaiting_reviewer` for display.

export type CapStatus =
  | "open"
  | "awaiting_evidence"
  | "in_progress"
  | "awaiting_reviewer"
  | "deferred"
  | "closed";

export const CAP_STATUS_META: Record<
  CapStatus,
  { label: string; className: string; helper: string }
> = {
  open: {
    label: "Open",
    className: "bg-muted text-muted-foreground border border-border",
    helper: "Work has not started.",
  },
  awaiting_evidence: {
    label: "Awaiting Evidence",
    className: "bg-amber-500/15 text-amber-700 border border-amber-500/30",
    helper: "Reviewer has requested evidence from the respondent.",
  },
  in_progress: {
    label: "In Progress",
    className: "bg-blue-500/15 text-blue-700 border border-blue-500/30",
    helper: "Remediation is underway.",
  },
  awaiting_reviewer: {
    label: "Awaiting Reviewer",
    className: "bg-yellow-500/15 text-yellow-700 border border-yellow-500/30",
    helper: "Submitted to the reviewer for validation.",
  },
  deferred: {
    label: "Deferred",
    className: "bg-muted text-muted-foreground border border-border",
    helper: "Deferred until the organization is ready to resume.",
  },
  closed: {
    label: "Closed",
    className: "bg-green-600/15 text-green-700 border border-green-600/30",
    helper: "Remediation accepted and closed by the reviewer.",
  },
};

export function normalizeCapStatus(raw?: string | null): CapStatus {
  const s = (raw || "open").toLowerCase();
  if (s === "submitted_for_review") return "awaiting_reviewer";
  if (s in CAP_STATUS_META) return s as CapStatus;
  return "open";
}

export const CAP_STATUS_OPTIONS: { value: CapStatus; label: string }[] = (
  Object.keys(CAP_STATUS_META) as CapStatus[]
).map((v) => ({ value: v, label: CAP_STATUS_META[v].label }));
